import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Header from './Header'

import CancellationList from '../Jobs/CancellationList'
import RevenueBoard from '../Jobs/RevenueBoard'

const MainRouter = (props) => {
    return (
        <div className="app-container">
            <Header />
            <Switch>
                <Route
                    exact
                    path="/RevenueBoard"
                    render={(routeProps) => (
                        <RevenueBoard />
                    )}
                />
                <Route
                    exact
                    path="/CancellationList"
                    render={(routeProps) => (
                        <CancellationList />
                    )}
                />
            </Switch>
        </div>
    );
};
export default MainRouter;
